import { render, staticRenderFns } from "./PercentageResultComponent.vue?vue&type=template&id=5ac3733b&scoped=true"
import script from "./PercentageResultComponent.vue?vue&type=script&lang=ts"
export * from "./PercentageResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3733b",
  null
  
)

export default component.exports